import React from "react";
import NoDataPlaceholderImage from "../../resources/images/icons/NoDataPlaceholderImage";

interface Props {
  text?: string | React.ReactElement;
  buttonText?: string;
  onButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
  iconHeight?: string | number;
  iconWidth?: string | number;
}

const NoDataPlaceholder: React.FC<Props> = ({
  text,
  buttonText,
  onButtonClick = () => {},
  iconHeight = "160px",
  iconWidth = "160px",
}) => {
  return (
    <div className="no_data_container">
      <div>
        <div
          style={{ height: iconHeight, width: iconWidth }}
        >
          <NoDataPlaceholderImage/>
      </div>
      </div>

      {text && <div className="no_data_text">{text}</div>}

      {buttonText && (
        <button
          className="foundit-button secondaryButton medium"
          onClick={onButtonClick}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default NoDataPlaceholder;
